import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// attach token if in localStorage as fallback
// - /member/* endpoints benötigen einen Member-Token
// - alles andere den Admin-/Mitarbeiter-Token
api.interceptors.request.use((config) => {
  if (config.headers.Authorization) return config;
  const url = String(config.url || "");
  const isMember = url.startsWith("/member/") || url.startsWith("member/");
  const key = isMember ? "mh_member_token" : "mh_token";
  const t = localStorage.getItem(key);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Ein Fehler ist aufgetreten.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
